AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Views", "Misc");

AoPS.Alcumus.Views.Misc = (function (AlcVMisc) {
	// Dependencies
	var compileTemplate = AoPS.View.compileTemplate;
	var Modal = AoPS.Ui.Modal;
	var AlcUrl = AoPS.Alcumus.Url;
	var AlcVBase = AoPS.Alcumus.Views.Base;
	var AlcVLog = AoPS.Alcumus.Views.Log;
	var AlcVActiveQuests = AoPS.Alcumus.Views.ActiveQuests;

	// Optional and can be loaded before or after this file
	// AoPS.Alcumus.Views.Admin

	AlcVMisc.SidebarContainer = AlcVBase.BaseView.extend({
		initialize: function (options) {
			// No template
			this.$el.addClass("grid");

			// Make subviews
			var master = this.model;
			var user_me = master.getUser("me");

			this.unregistered_panel = new AlcVMisc.UnregisteredPanel({
				model: master,
			});
			this.navigation_bar = new AlcVMisc.NavigationBar({model: master});
			this.quest_panel = new AlcVActiveQuests.MainPanel({model: user_me});
			this.log_panel = new AlcVLog.MainPanel({model: user_me});
			this.internal_ad = new AlcVMisc.InternalAd();

			this.addSubviewToLocation(this.unregistered_panel, "");
			this.addSubviewToLocation(this.navigation_bar, "");
			this.addSubviewToLocation(this.quest_panel, "");
			this.addSubviewToLocation(this.log_panel, "");
			this.addSubviewToLocation(this.internal_ad, "");

			// Panel visibility.

			// Two are usually hidden until we hit the problem
			// page (see setCurrentPage).
			this.quest_panel.$el.hide();
			this.log_panel.$el.hide();

			// The rest are based on whether the user is logged in.
			// Assume logged in for now...
			this.unregistered_panel.$el.hide();
			// ... but adjust appropriately if we can verify user isn't logged in.
			master.requestLoad(function (ok, data) {
				if (ok && !AoPS.session.logged_in) {
					this.unregistered_panel.$el.show();
				} else if (ok && !AoPS.session.initialized) {
					// Don't show nav bar if user is uninitialized. None of the pages
					// will work for them anyways.
					this.navigation_bar.$el.hide();
				}
			}, this);
			this.internal_ad.$el.show();
			this.render();
		},

		hasSubmenu: function (page) {
			return page === "help" || page === "hall_of_fame";
		},

		setCurrentPage: function (page, subpage) {
			this.navigation_bar.setCurrentPage(page, subpage);

			if (AoPS.session.logged_in_and_initialized) {
				this.quest_panel.$el.toggle(page === "problem");
				this.log_panel.$el.toggle(!this.hasSubmenu(page));
				// Log panel needs a few extra calls for each page change
				this.log_panel.skipAnimation();
				this.log_panel.setHeight();
			}
		},

		// Just forwards to navigation bar
		setSubmenu: function (page, menu_data) {
			return this.navigation_bar.setSubmenu(page, menu_data);
		},
	});

	AlcVMisc.UnregisteredPanel = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-unregistered");

			this.render();
		},

		events: {
			"click .alc--login": "onLogin",
			"click .alc--register": "onRegister",
		},

		onLogin: function () {
			AoPS.login.display();
		},

		onRegister: function () {
			AoPS.login.goToRegister();
		},
	});

	AlcVMisc.InternalAd = AlcVBase.BaseView.extend({
		initialize: function (options) {
			var html =
				'<div class="ready-for-next">' +
				'<a href="/school">' +
				'<img src="/assets/images/internalads/vertical.jpg"></img>' +
				"</a></div>";
			this.renderSimple(html);
		},
	});

	AlcVMisc.NavigationBar = AlcVBase.BaseView.extend({
		button_table: [
			// url_data here is the parameters to hand to AlcUrl.getUrl.
			// page is the value sent to setCurrentPage by the router.
			// caption is what's actually displayed on the button itself.
			{url_data: ["problem"], page: "problem", caption: "Play"},
			{url_data: ["profile", "me"], page: "profile", caption: "Profile"},
			{url_data: ["report", "me"], page: "report", caption: "Report"},
			{
				url_data: ["hall_of_fame"],
				page: "hall_of_fame",
				caption: "Hall of Fame",
			},
			{url_data: ["help"], page: "help", caption: "Help"},
			{url_data: ["settings"], page: "settings", caption: "Settings"},
		],

		initialize: function (options) {
			this.nav_buttons = {};

			var AlcVAdmin = AoPS.Alcumus.Views.Admin;
			if (AlcVAdmin) {
				this.button_table.push({
					url_data: ["admin"],
					page: "admin",
					caption: "Admin",
				});
			}

			_.each(
				this.button_table,
				function (button_data) {
					// Compute the URL from the url_data array.
					var url = AlcUrl.getUrl.apply(AlcUrl, button_data.url_data);
					// Make sure the view gets the model and URL along with the rest.
					button_data = _.extend({model: this.model, url: url}, button_data);

					this.nav_buttons[button_data.page] = new AlcVMisc.NavigationBarButton(
						button_data
					);
					this.addSubviewToLocation(this.nav_buttons[button_data.page], "");
				},
				this
			);

			this.render();
		},

		updateNavButtons: function () {
			// Update which button is shown as selected
			_.each(
				this.nav_buttons,
				function (nav_button, page) {
					nav_button.setSelected(this.current_page === page);
					// Button knows this is a no-op if it's not selected.
					nav_button.setSubpage(this.current_subpage);
				},
				this
			);
		},

		setCurrentPage: function (page, subpage) {
			this.current_page = page;
			this.current_subpage = subpage;
			this.updateNavButtons();
		},

		// Propagates straight into a button's setSubmenu
		setSubmenu: function (page, menu_data) {
			this.nav_buttons[page] && this.nav_buttons[page].setSubmenu(menu_data);
		},

		postRender: function () {
			// TODO: Hack because wtf was I thinking making this view so constrained
			if (this.model.isTeacher()) {
				var teacherNavTpl = compileTemplate("#alc-tpl-nav-bar-teacher");
				this.$el.prepend($($.parseHTML(teacherNavTpl())));
			}

			this.updateNavButtons();
		},
	});

	AlcVMisc.NavigationBarButton = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-nav-bar-button");

			this.url = options.url;
			this.caption = options.caption;
			this.is_selected = false;

			this.render();
		},

		setSelected: function (new_val) {
			this.is_selected = !!new_val;
			this.$el.toggleClass("open", !!new_val);
			this.setSubpage(null);
		},

		// Kind of hackish. Call only after rendering; it will manually inject
		// the submenu into the view if not already there. Assumes populating
		// the submenu is a one-time static computation that never needs to
		// be updated.
		// No current plans to make this one more elegant; not anticipating
		// that the navigation bar will get much more complicated.
		setSubmenu: function (menu_data) {
			if (this.$(".submenu-wrapper").length) {
				// Already constructed the submenu; just leave it there.
				return;
			}

			var submenuTpl = compileTemplate("#alc-tpl-nav-bar-submenu");
			this.$el.append($($.parseHTML(submenuTpl({menu_data: menu_data}))));
		},

		// Must be a no-op if the button is not selected.
		setSubpage: function (key) {
			if (!this.$(".submenu").length) {
				return;
			}
			this.$(".submenu a.active").removeClass("active");

			if (!key || !this.is_selected) {
				return;
			}
			var subsel = '.submenu a[data-key="' + key + '"]';
			this.$(subsel).addClass("active");
		},

		getContext: function () {
			return {
				url: this.url,
				caption: this.caption,
			};
		},

		postRender: function () {
			var url = this.url;
			this.$el.toggleClass("open", !!this.is_selected);

			this.$el.click(function (evt) {
				Backbone.trigger("alc_goto_url", url);
				Backbone.trigger("alc_show_problem");
			});
		},
	});

	AlcVMisc.Introduction = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-cms-intro");

			this.model.requestLoad(function (ok, data) {
				this.render();
			}, this);
			this.renderLoading();
		},

		events: {
			"click .alc--login": "onLogin",
			"click .alc--register": "onRegister",
		},

		onLogin: function () {
			AoPS.login.display();
		},

		onRegister: function () {
			AoPS.login.goToRegister();
		},

		getContext: function () {
			return {logged_in: AoPS.session.logged_in};
		},
	});

	$(function () {
		Handlebars.registerPartial(
			"hall-of-fame-entry",
			compileTemplate("#alc-tpl-hall-of-fame-entry")
		);
	});

	// Base class; not constructed directly
	AlcVMisc.KeyedPanelList = AlcVBase.BaseView.extend({
		// Return array recognized by AlcUrl. Override in derived class.
		getKeyUrl: function (key) {},

		getKeyList: function () {
			return _.map(
				this.$("div[data-key]"),
				function (el) {
					var $el = $(el);
					var key = $el.attr("data-key");
					return {
						key: key,
						url_data: this.getKeyUrl(key),
						label: $el.find(".header h3").text(),
					};
				},
				this
			);
		},

		scrollToSection: function (section_id) {
			var el = this.$('div[data-key="' + section_id + '"]');
			if (!el.length) {
				return;
			}
			el.removeClass("closed");
			$("html,body").scrollTop(el.offset().top - 20);
		},

		postRender: function () {
			this.$(".grey-panel > .toggle, .grey-panel > .header").on(
				"click",
				function () {
					$(this).parent().toggleClass("closed");
				}
			);
		},
	});

	AlcVMisc.HallOfFame = AlcVMisc.KeyedPanelList.extend({
		MAX_AVATAR_DIM: 30,

		initialize: function () {
			this.setTemplateAndUseRootEl("alc-tpl-hall-of-fame");

			this.model.requestLoad(function (ok, data) {
				if (!ok && data.error_code === "E_HALL_OF_FAME_NOT_READY") {
					return this.renderSimple(
						this.getErrorBox({
							intro: " ",
							error_msg:
								"The Alcumus Hall of Fame has been temporarily disabled " +
								"for performance reasons. We apologize for the inconvenience.",
						})
					);
				} else if (!ok) {
					return this.renderError(data);
				}
			}, this);

			this.renderLoading();
			this.listenTo(this.model, "loaded", _.bind(this.render, this));
		},

		events: {
			"click .load-friend-data": "loadFriendData",
		},

		loadFriendData: function (e) {
			var $target = $(e.target);
			var key = $target.attr("key");

			AoPS.Page.$loader.clone().insertAfter($target.hide());
			this.model.loadHallOfFameFriendList(key);
		},

		getKeyUrl: function (key) {
			return ["hall_of_fame_section", key];
		},

		// Returns [width, height]
		scaleAvatar: function (width, height) {
			var max_dim = Math.max(width, height);
			var scale = Math.min(this.MAX_AVATAR_DIM / max_dim, 1);
			return [scale * width, scale * height];
		},

		getListContext: function (key, list_data) {
			var scaleAvatar = _.bind(this.scaleAvatar, this);
			var getEntry = this.model.getEntryWriter(key);
			return _.map(_.compact(list_data), function (node) {
				var avatar_data = node.avatar_data || [];
				var avatar_size = scaleAvatar(avatar_data[1], avatar_data[2]);
				return {
					avatar_url: avatar_data[0],
					avatar_width: avatar_size[0],
					avatar_height: avatar_size[1],
					user_id: node.user_id,
					username: node.username,
					entry_text: getEntry(node),
				};
			});
		},

		getContext: function () {
			var model = this.model;

			return {
				fields: _.map(
					model.getKeys(),
					function (key) {
						var list_data = this.model.get(key);
						var result = {
							key: key,
							title: model.getTitle(key),
							friend_entries: [],
							all_entries: [],
						};

						if (list_data && _.isUndefined(list_data.friends)) {
							result.friend_entries_is_undefined = true;
						} else if (list_data && list_data.friends) {
							result.friend_entries = this.getListContext(
								key,
								list_data.friends
							);
						}

						if (list_data && list_data.all) {
							result.all_entries = this.getListContext(key, list_data.all);
						}

						return result;
					},
					this
				),
			};
		},
	});

	AlcVMisc.Help = AlcVMisc.KeyedPanelList.extend({
		initialize: function () {
			this.setTemplateAndUseRootEl("alc-cms-help");
			this.render();
		},

		getKeyUrl: function (key) {
			return ["help_section", key];
		},
	});

	AlcVMisc.Settings = AlcVBase.BaseView.extend({
		initialize: function () {
			this.setTemplateAndUseRootEl("alc-tpl-settings-panel");

			this.listenTo(this.model, "change", this.syncShownValuesWithModel);

			this.render();
		},

		events: {
			'click input[type="radio"]': "onRadioChange",
		},

		syncShownValuesWithModel: function () {
			var excluded_fields = [];

			if (this.model.get("user").get("limited_access")) {
				excluded_fields = ["public_profile", "stats"];
			}

			_.each(
				this.model.settings_format,
				function (format_node) {
					var current_value;
					var row_el;
					var opt_el;

					current_value = this.model.get(format_node.name);
					row_el = this.$(
						'.alc-settings-row[data-name="' + format_node.name + '"]'
					);

					if (_.indexOf(excluded_fields, format_node.name) >= 0) {
						row_el.hide();
					} else {
						// Radio; just need to set initial value
						opt_el = row_el.find('input[value="' + current_value + '"]');
						opt_el = opt_el || row_el.find('input[value="0"]');
						opt_el.prop("checked", true);
					}
				},
				this
			);
		},

		onRadioChange: function (evt) {
			var target = evt.currentTarget;
			var name = target.getAttribute("name");
			var edit_vals = {};
			edit_vals[name] = target.value;
			this.model.edit(
				edit_vals,
				function (ok, data) {
					var parent;
					if (!ok) {
						AlcVBase.showModalError(
							"An error occurred when trying to change your settings.",
							data
						);
					} else {
						parent = $(target).parent();
						parent
							.css("background-color", "#ff7")
							.animate({"background-color": "transparent"});
					}
				},
				this
			);
		},

		getContext: function () {
			return {format: this.model.settings_format};
		},

		postRender: function () {
			this.syncShownValuesWithModel();
		},
	});

	AlcVMisc.ResetPanel = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-reset-panel");

			this.caption = "Reset all Alcumus data";

			this.render();
		},

		events: {
			"click .alc-reset-button": "onReset",
			"change .alc-reset-input": "onInputChange",
		},

		onResetConfirm: function (response) {
			if (response !== "RESET") {
				Modal.showAlert(
					"You did not type in the correct message, so your data was not reset.",
					{
						onClose: function () {
							Backbone.trigger("alc_goto_url", AlcUrl.getUrl("problem"));
							Modal.closeAllModals();
						},
					}
				);
				return;
			}

			Modal.showAlert("Please wait while your Alcumus data is being reset...");

			this.model.startReset(response, function (ok, data) {
				Modal.closeTopModal();

				if (!ok && data.error_code === "E_RESET_DENIED") {
					Modal.showAlert(data.error_msg, {
						onClose: function () {
							Backbone.trigger("alc_goto_url", AlcUrl.getUrl("problem"));
							Modal.closeAllModals();
						},
					});
				} else if (!ok) {
					AlcVBase.showModalError("An error occurred while resetting.", data);
				} else {
					Modal.showAlert("Your Alcumus data has been reset.", {
						onClose: function () {
							window.location = "/alcumus/problem";
							Modal.closeAllModals();
						},
					});
				}
			});
		},

		onReset: function () {
			var modalTpl = compileTemplate("#alc-tpl-modal-reset-confirm");
			var modal_el = $($.parseHTML(modalTpl()));

			var handler = _.bind(function (value) {
				if (value === "cancel") {
					Modal.closeAllModals();
				} else {
					this.onResetConfirm(modal_el.find("input").val());
				}
			}, this);

			Modal.showButtons(
				modal_el,
				[
					{text: "Go", value: "go"},
					{text: "Cancel", value: "cancel"},
				],
				handler,
				{
					title: "Confirm Reset",
					close_on_button_click: false,
				}
			);
		},

		getContext: function () {
			return {
				caption: this.caption,
			};
		},
	});

	return AlcVMisc;
})(AoPS.Alcumus.Views.Misc);
